import { useCallback, useEffect, useState } from 'react';

/**
 * Measures a chart container's clientWidth via ResizeObserver so axis layout
 * can choose flat vs angled ticks from real width.
 *
 * Uses a callback ref so measurement still works when the chart box mounts
 * after an early loading/empty return (common on Domain / Invoicing).
 */
export function useChartContainerWidth() {
    const [element, setElement] = useState<HTMLDivElement | null>(null);
    const [width, setWidth] = useState(0);

    const ref = useCallback((node: HTMLDivElement | null) => {
        setElement(node);
    }, []);

    useEffect(() => {
        if (!element) {
            setWidth(0);
            return;
        }

        const update = () => setWidth(element.clientWidth);
        update();

        const observer = new ResizeObserver(update);
        observer.observe(element);
        return () => observer.disconnect();
    }, [element]);

    return [ref, width] as const;
}
